export default {"src":"/_next/static/media/mask-icon.0a5c5ba3.svg","height":25,"width":24};